import { useEffect } from "react";
import { usePreproductPreviewContext } from "../context/Context";
import { PREPROD_PREVIEW_ACTIONS } from "../context/types";
export var useFullscreenListener = function() {
    var dispatch = usePreproductPreviewContext().dispatch;
    useEffect(function() {
        var onMessage = function(event) {
            if (event.data.type === "LITE_USE_FULLSCREEN") {
                dispatch({
                    type: PREPROD_PREVIEW_ACTIONS.TOGGLE_MODAL
                });
            }
        };
        window.addEventListener("message", onMessage);
        return function() {
            return window.removeEventListener("message", onMessage);
        };
    }, [
        dispatch
    ]);
};
